var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McLayoutForm',[(_vm.loadingState)?_c('div',[_c('McSpinner',{attrs:{"large":""}})],1):_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('general.Error')))]),_c('p',[_vm._v(_vm._s(_vm.$t('users.InvalidConfirmationToken')))]),_c('p',[_vm._v(_vm._s(_vm.$t('users.RetryChanging')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }